import React, { useState, useEffect } from 'react';
import { Button } from 'reactstrap';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import CadastroDocumento from './Components/CadastroDocumento';

//Api
import documento_api from '../../../../api/documento_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

//Contanst
import { actionsTable } from '../../../../constants/MaterialTable';

export default function Documentos({ permissoes }) {

    //Estado de controle de exibição da tela de cadastro de documentos
    const [cadastro, setCadastro] = useState(false);

    //Estado de controle da lista de documentos
    const [documentos, setDocumentos] = useState([]);

    //Estado de controle de visualização de um documento especifico
    const [idDocumento, setIdDocumento] = useState(null);

    //Pegando o estado de controle do loading na tela
    const { setLoading } = useAuth();

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Função do botão visualizar da lista
    const editar = (rowData) => {
        setIdDocumento(rowData.id)
    };

    const visualizar = (rowData) => {
        setIdDocumento(rowData.id)
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editar)]
            : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Documento", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ]

    //Função que carrega a lista de documentos
    const loadDocumentos = () => {
        setLoading(true);
        documento_api.getList().then(response => {
            setDocumentos(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        loadDocumentos();
    }, []);

    const handleVoltar = () => {
        setCadastro(false);
        setIdDocumento(null);
        loadDocumentos();
    }

    if (cadastro || idDocumento)
        return <CadastroDocumento btnVoltar={handleVoltar} id={idDocumento} editavel={editavel} />

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>Documentos</h4>
                {editavel &&
                    <Button color='success' onClick={() => { setCadastro(true) }}>+ Cadastrar</Button>
                }
            </div >
            <TabelaListagem
                actions={actions}
                title={"Lista de Documentos"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={documentos}
            />
        </>
    )
}